import React from 'react';

const Welcome = () => {
    return (
        <>
            <div className='bg-light'>
                <div className="container">
                    <div style={{ padding: "80px 0" }}>
                        <h2 className='text-center mb-3'>আমের বাড়ী সম্পর্কে </h2>
                        <p className='text-justify'>রাজশাহী এবং চাঁপাইনবাবগঞ্জের ফরমালিনমুক্ত অরগানিক আমের বিশাল সমাহার পাবেন আমের বাড়িতে, আমাদের নিজেদের তত্ত্বাবধানে সম্পূর্ণ প্রাকৃতিক উপায়ে বেড়ে ওঠা গাছ পাকা আম পেতে আমাদের আমাদের সাথে যোগাযোগ করুন।</p>
                        <h4 className='m-0'>যোগাযোগ:</h4>
                            <p className='m-0'>Aman Ullah</p>
                            <p className='m-0'>Phone: 01774659710</p>
                            <p className='m-0'>Hridoy</p>
                            <p className='m-0'>Phone: 01703695796</p>
                    </div>
                </div>

            </div>
        </>
    );
};

export default Welcome;
